// utils/translations.js
const translations = {
    fr: {
        appTitle: "Hatann'App",
        appSubtitle: "Chasses au trésor et escape games",//
        homeScreen: "Accueil",//
        myAccount: "Mon espace",//
        partnerCorner: "Espace partenaire",//
        contactUs: "Nous contacter",//
        termsOfUse: "Conditions d'utilisation",//
        adminPanel: "Panneau d'administration",//
        logout: "Me déconnecter",//
        login: "Me connecter"//
    },
    en: {
        appTitle: "Hatann'App",
        appSubtitle: "Treasure hunts and escape games",
        homeScreen: "Home",
        myAccount: "My Account",
        partnerCorner: "Espace partenaire",
        contactUs: "Contact Us",
        termsOfUse: "Terms of Use",
        adminPanel: "Admin Panel",
        logout: "Log out",
        login: "Log in"
    },
    de: {
        appTitle: "Hatann'App",
        appSubtitle: "Schatzsuchen und Escape Games",
        homeScreen: "Startseite",
        myAccount: "Mein Bereich",
        partnerCorner: "Partnerbereich",
        contactUs: "Kontakt",
        termsOfUse: "Nutzungsbedingungen",
        adminPanel: "Admin-Bereich",
        logout: "Abmelden",
        login: "Anmelden"
    },
    es: {
        appTitle: "Hatann'App",
        appSubtitle: "Búsquedas del tesoro y juegos de escape",
        homeScreen: "Inicio",
        myAccount: "Mi cuenta",
        partnerCorner: "Espacio de socios",
        contactUs: "Contáctanos",
        termsOfUse: "Términos de uso",
        adminPanel: "Panel de administración",
        logout: "Cerrar sesión",
        login: "Iniciar sesión"
    },
    it: {
        appTitle: "Hatann'App",
        appSubtitle: "Cacce al tesoro e escape games",
        homeScreen: "Home",
        myAccount: "Il mio spazio",
        partnerCorner: "Area partner",
        contactUs: "Contattaci",
        termsOfUse: "Termini di utilizzo",
        adminPanel: "Pannello di amministrazione",
        logout: "Disconnettersi",
        login: "Accedi"
    }
};

export default translations;
